(function() {
    // Function to open Rebuy Smart Cart safely
    const openRebuyCart = () => {
        if (window.Rebuy && window.Rebuy.SmartCart) {
            console.log('Opening Rebuy Smart Cart...');
            window.Rebuy.SmartCart.show();
        } else {
            console.warn('Rebuy Smart Cart not loaded yet, retrying in 300ms...');
            setTimeout(openRebuyCart, 300);
        }
    };

    // Attach event listener to cart icon safely
    const attachCartListener = () => {
        const cartIcon = document.querySelector('.header-actions__cart-icon');

        if (cartIcon) {
            console.log('Cart icon found, attaching event listeners.');

            // Use multiple events for all devices
            ['pointerup', 'touchend', 'click'].forEach(eventType => {
                cartIcon.addEventListener(eventType, (e) => {
                    e.preventDefault();
                    console.log(`Cart icon activated (${eventType})`);
                    openRebuyCart();
                });
            });

            // Listen for the Rebuy cart drawer opening
            document.addEventListener('rebuy:smartcart.show', (event) => {
                console.log('Rebuy Smart Cart drawer is now open!', event.detail.smartcart);
            });
        } else {
            console.warn('Cart icon not found yet, retrying...');
            setTimeout(attachCartListener, 500);
        }
    };

    // Wait for Rebuy Smart Cart to load
    const waitForRebuy = () => {
        if (window.Rebuy && window.Rebuy.SmartCart) {
            console.log('Rebuy Smart Cart loaded, attaching listeners...');
            attachCartListener();
        } else {
            console.log('Waiting for Rebuy Smart Cart to load...');
            setTimeout(waitForRebuy, 300);
        }
    };

    // Start after DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForRebuy);
    } else {
        waitForRebuy();
    }
})();
